const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const BOUNDARY_END = '(?![\\p{L}\\p{N}])';

const keywordRegExpCache = new WeakMap<readonly string[], RegExp | null>();

const buildKeywordPattern = (keyword: string): string | null => {
	const trimmed = keyword.trim();
	if (!trimmed) {
		return null;
	}
	return escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
};

const buildKeywordsRegExp = (keywords: readonly string[]): RegExp | null => {
	const cached = keywordRegExpCache.get(keywords);
	if (cached !== undefined) {
		return cached;
	}

	const patterns = keywords.reduce<string[]>((result, keyword) => {
		const pattern = buildKeywordPattern(keyword);
		if (pattern) {
			result.push(pattern);
		}
		return result;
	}, []);
	const regExp = patterns.length
		? new RegExp(`${BOUNDARY_START}(?:${patterns.join('|')})${BOUNDARY_END}`, 'iu')
		: null;
	keywordRegExpCache.set(keywords, regExp);
	return regExp;
};

export const matchMeetingSignal = (text: string, keywords: readonly string[]): boolean => {
	if (!text || keywords.length === 0) {
		return false;
	}
	return buildKeywordsRegExp(keywords)?.test(text) ?? false;
};
